import React, {useState} from 'react';

import {words5} from '#Common/dictionaries/dictionary5';

type Props = {
  setSelectedWord: (word: string) => void;
};

export const WordFilter = ({setSelectedWord}: Props) => {
  const [filterText, setFilterText] = useState<string>('');
  return (
    <div>
      <input
        autoCapitalize="none"
        type="text"
        value={filterText}
        onChange={event => setFilterText(event.target.value.toLowerCase())}
      />
      <table>
        <tbody>
          {Array.from(words5)
            .filter(word => word.indexOf(filterText) !== -1)
            .map(word => (
              <tr key={word}>
                <td>{word}</td>
                <td>
                  <button onClick={() => setSelectedWord(word)}>View</button>
                </td>
              </tr>
            ))}
        </tbody>
      </table>
    </div>
  );
};
